<input #inputRef *ngIf="!disabled" type="text" pInputText [(ngModel)]="value" (blur)="onBlur($event)"
  [ngClass]="isValid? 'ng-valid' : 'ng-invalid ng-dirty p-inputtext-invalid'"
  (keypress)="onKeyPress($event)"
  (keyup)="onKeyUp($event)"
  (paste)="omitIllegalCharactersOnPaste($event)"
/>

<span *ngIf="disabled">{{value}}</span>